import { useMemo } from "react";

import DataAggregator from "../dataAggregator/DataAggregator";
import ContentCard from "../../pages/loggedIn/content/ContentCard";
import CertificateCard from "../../pages/loggedIn/certification/CertificateCard";

export default function SentCertificateAggregator({
  columns = 1,
  userId,

  hideTitleSection,
  nothingFoundMessage,
}) {
  const queryParams = useMemo(
    () => ({
      userId,
    }),
    [userId]
  );

  return (
    <DataAggregator
      hideTitleSection={hideTitleSection}
      nothingFoundMessage={nothingFoundMessage}
      columns={columns}
      disableFilters={true}
      queryParams={queryParams}
      title="Certificates"
      path="certificates-sent"
      CardComponent={CertificateCard}
    />
  );
}
